export const GLOBAL_STATE = 'EducationPlace'

export const EDUCATION_PLACE = 'educationPlace'
export const EDUCATION_PLACE_LIST = 'educationPlaceList'
export const EDUCATION_PLACE_ALL = 'educationPlaceAll'
export const EDUCATION_PLACE_CREATE = 'educationPlaceCreate'
